// extracted by mini-css-extract-plugin
export default {"home":"Home_home__AwGY-","rewievs":"Home_rewievs__L2G7a"};